import React from 'react'
import HeaderTitle from 'components/shared/HeaderTitle'

export default () => <HeaderTitle title='Annotations' />
